import { NgModule } from '@angular/core';
import { SelectCompanyAccountStoreService } from './select-company-account-store.service';

@NgModule({
  providers: [SelectCompanyAccountStoreService],
})
export class SelectCompanyAccountStoreServiceModule {}
